import React from "react";
import "./App.css";
import { useRoutes } from "react-router-dom";
import { appRoutes } from "./routes/AppRoutes";

const App: React.FC = () => {
  const AppRoutes = useRoutes(appRoutes);
  return AppRoutes;
};

export default App;
